import React from 'react';
import { Col, Row } from '../../../lib/utils';
import {
    Body1Bold,
    Body1Regular,
    Body2Bold,
    Body2Light,
    Body3Bold,
    Body3Light,
    Body3Regular,
    Head4,
} from '../../../lib/font';
import { I_LEFT_ANGLE, I_PRIMARY_LEFT_TRIANGLE, I_PRIMARY_RIGHT_TRIANGLE, I_RIGHT_ANGLE } from '../../../types/images';
import { colors } from '../../../lib/colors';
import dayjs from 'dayjs';
import ThreeButton from '../../Button/ThreeButton';
import ResetButton from '../../Button/ResetButton';

type Props = {
    currentDate: any;
    onClickSubtractDate: () => void;
    onClickAddDate: () => void;
    isToday: boolean;
    isWeek: boolean;
    isMonth: boolean;
    settingDate: (type: string) => void;
    weekNumber: number;
    setCurrentDate: any;
    authObject: any;

    dayCancelCount: number;
    dayChangeCount: number;
    weekCancelCount: number;
    weekChangeCount: number;
    monthCancelCount: number;
    monthChangeCount: number;
};

const ScheduleHistoryGraphHeader = ({
    currentDate,
    onClickSubtractDate,
    onClickAddDate,
    isToday,
    isWeek,
    isMonth,
    settingDate,
    weekNumber,
    setCurrentDate,
    authObject,

    dayCancelCount,
    dayChangeCount,
    weekCancelCount,
    weekChangeCount,
    monthCancelCount,
    monthChangeCount,
}: Props) => {
    return (
        <Col>
            <Body1Bold style={{ marginLeft: 70, marginTop: 48 }}>당일 취소 및 변경 횟수</Body1Bold>
            <Row
                style={{
                    marginTop: 24,
                    alignItems: 'center',
                    marginLeft: 70,
                    justifyContent: 'space-between',
                    paddingRight: 70,
                }}
            >
                <Row>
                    <Row
                        style={{
                            width: 232,
                            height: 32,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginRight: 24,
                        }}
                    >
                        <button style={{ width: 24, height: 24 }} onClick={() => onClickSubtractDate()}>
                            <img src={I_LEFT_ANGLE} style={{ width: 24, height: 24 }} />
                        </button>
                        <Body3Regular style={{ width: 160, textAlign: 'center', color: colors.LAVEL_2 }}>
                            {isToday && currentDate.format('MM월') + weekNumber + '주차'}
                            {isWeek && currentDate.format('YYYY년 MM월')}
                            {isMonth && currentDate.format('YYYY년')}
                        </Body3Regular>
                        <button style={{ width: 32, height: 32 }} onClick={() => onClickAddDate()}>
                            <img src={I_RIGHT_ANGLE} style={{ width: 24, height: 24 }} />
                        </button>
                    </Row>
                    <ThreeButton
                        isFirst={isToday}
                        isSecond={isWeek}
                        isThird={isMonth}
                        firstText={'일간'}
                        secondText={'주간'}
                        thirdText={'월간'}
                        firstCallBack={() => settingDate('today')}
                        secondCallBack={() => settingDate('thisWeek')}
                        thirdCallBack={() => settingDate('thisMonth')}
                    />
                    {/* 초기화 버튼 */}
                    <ResetButton style={{ marginLeft: 24 }} callBack={() => setCurrentDate(dayjs())} />
                </Row>

                <Row style={{ justifyContent: 'space-between' }}>
                    <Row
                        style={{
                            height: 24,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                width: 16,
                                height: 16,
                                borderRadius: 2,
                                backgroundColor: colors.ERROR,
                                marginRight: 8,
                            }}
                        />
                        <Body3Regular style={{ color: colors.LAVEL_3 }}>{`취소 수업`}</Body3Regular>
                    </Row>

                    <Row
                        style={{
                            height: 24,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginLeft: 24,
                        }}
                    >
                        <div
                            style={{
                                width: 16,
                                height: 16,
                                borderRadius: 2,
                                backgroundColor: colors.BLUE_500,
                                marginRight: 8,
                            }}
                        />
                        <Body3Regular style={{ color: colors.LAVEL_3 }}>{`변경 수업`}</Body3Regular>
                    </Row>
                </Row>
            </Row>
        </Col>
    );
};

export default ScheduleHistoryGraphHeader;
